"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var getState_1 = require("../../../../utils/getState");
var CompanyDetails = function (_a) {
    var name = _a.name, details = _a.details;
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", { htmlFor: "name" }, "Company name"),
                React.createElement("input", { value: name, onChange: function (e) { return (name = e.target.value); }, disabled: true })),
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Phone Number"),
                React.createElement("input", { value: details.phone, disabled: true })),
            details.companies_house_number !== null && (0, getState_1.default)().user.role !== 'customer' ? (React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Companies House No."),
                React.createElement("input", { value: details.companies_house_number, disabled: true }))) : null,
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Address Line 1"),
                React.createElement("input", { value: details.address_line_1, disabled: true })),
            details.address_line_2 ? (React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Address Line 2"),
                React.createElement("input", { value: details.address_line_2, disabled: true }))) : null,
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Town/City"),
                React.createElement("input", { value: details.address_town, disabled: true })),
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "County"),
                React.createElement("input", { value: details.address_county, disabled: true })),
            React.createElement("div", { className: "form-input full-width" },
                React.createElement("label", null, "Postcode"),
                React.createElement("input", { value: details.address_postcode, disabled: true })))));
};
exports.default = CompanyDetails;
